import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BsPlusLg } from "react-icons/bs";
import { Container, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Col } from "reactstrap";
import CreateTableComponent from '../share/CreateTableComponent';
import { Formik, Form, Field } from "formik";
import { Loading } from "../share/loading";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import "../share/form.css";
import Swal from "sweetalert2";
import DatePicker, { registerLocale } from "react-datepicker";
import th from 'date-fns/locale/th';
import { th as thBuddhist } from 'date-fns/esm/locale';
import { format } from 'date-fns';
import { addYears } from 'date-fns/esm/fp';
import 'react-datepicker/dist/react-datepicker.css'
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import { NumberWithCommas } from "../share/NumberWithCommas";
import Select from 'react-select';
import { GetVMdDept } from "../share/api/MasterDataApi";
import { FormikSelect } from "../share/FormikSelect";
import { ReplaceNullWithEmptyString } from "../share/ReplaceNullWithEmptyString";

export function CreateSupportAnnounce10EstimateComponent() {
    registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })
    const range = (start, end) => {
        return new Array(end - start).fill().map((d, i) => i + start);
    };
    const thaiMonths = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
    ];
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก

    const years = range(1963, getYear(new Date()) + 8, 1);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type");
    const [lawOcuData, setLawOcuData] = useState([]);
    const [testLawOcuData, setTestLawOcuData] = useState([]);
    const [currentSupportForm, setCurrentSupportForm] = useState(null);

    const [listregisterOptions, setListRegisterOptions] = useState([]);
    const [selectRegisterId, setSelectRegisterId] = useState(0);
    // console.log("currentSupportForm", currentSupportForm);
    const [dataAnnounce11, setDataAnnounce11] = useState([]);
    console.log("dataAnnounce11", dataAnnounce11);
    const user = JSON.parse(localStorage.getItem("userData"));
    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);

    // สำหรับใส่ที่อยู่สถานที่ตั้งศูนย์ดำเนินการทดสอบ
    const [testProvince, setTestProvince] = useState([]);
    const [testAmphur, setTestAmphur] = useState([]);
    const [testTumbon, setTestTumbon] = useState([]);
    const [dataRegister, setDataRegister] = useState([]);

    //state ประกาศ 11
    const [openModalAnnounce11, setOpenModalAnnounce11] = useState(false);
    const modalToggleAnnounce11 = () => setOpenModalAnnounce11(!openModalAnnounce11);
    const [selectAnnounce11Item, setSelectAnnounce11Item] = useState(null);
    const [isAnnounce11Editing, setIsAnnounce11Editing] = useState(false);
    const [conditionDate, setConditionDate] = useState(null);

    const [userProfile, setUserProfile] = useState(null);
    const [userAuthRegister, setUserAuthRegister] = useState([]);

    const [calculateAmount, setCalculateAmount] = useState(0);

    useEffect(() => {
        GetAmphur(userProfile?.address?.provinceCode);
        GetTumbon(userProfile?.address?.provinceCode, userProfile?.address?.amphurCode);
    }, [userProfile])


    const getProfile = async () => {
        try {
            let formData = new FormData();
            formData.append("registerId", selectRegisterId ?? 0)
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
                body: formData
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (supportId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue("coordinateName", resJson.dataenum.contactorName);
                formikRef.current?.setFieldValue("coordinatePhone", resJson.dataenum.contactorPhone);
                formikRef.current?.setFieldValue("coordinateMobile", resJson.dataenum.phone);
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }

        } catch (e) {
            console.log("err", e)
        }
    };

    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        GetProvince();
        GetTitleName();
        GetLawOcu();
        getCondition();
        getProfile();
    }, []);

    const getCondition = async () => {
        let id = 9;
        try {
            let res = await fetch(`api/SupportForm/getConditionSupport/${id}`)
            let resJson = await res.json();
            console.log(resJson.dataenum);
            // setConditionData(resJson.dataenum);

            resJson.dataenum?.map((condition) => {
                // setConditionOne(condition.condition1);
                // setConditionTwo(condition.condition2);
                setConditionDate(condition.conditionDate);
            })
            return resJson.dataenum;

        } catch (e) {
            console.log('err => ', e)
        }
    }

    async function GetAmphur(provinceCode) {
        let postData = new FormData();
        postData.append("provinceCode", provinceCode);

        try {
            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                method: "POST",
                body: postData
            });
            const amphurData = await responseAmphur.json()
            setTestAmphur(amphurData.dataenum);
            // console.log(amphurData.dataenum);

        } catch (err) {
            // console.log("err =>" + err);
        }
    }

    async function GetTumbon(provinceCode, amphurCode) {
        let postData = new FormData();
        postData.append("provinceCode", provinceCode);
        postData.append("amphurCode", amphurCode);
        try {
            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                method: "POST",
                body: postData
            });
            const tumbonData = await responseTumbon.json()
            setTestTumbon(tumbonData.dataenum);

        } catch (err) {
            // console.log("err =>" + err);
        }
    };

    //ดึงข้อมูลแบบฟอร์มอุดหนุน
    useEffect(() => {
        const GetCurrentSupportForm = async () => {
            if (supportId !== "0") {
                let postData = new FormData();
                postData.append("supportId", Number(supportId));
                postData.append("supportTypeId", Number(supportTypeId));
                setLoading(true);
                try {
                    let res = await fetch("/api/SupportForm/getSupportFormData", {
                        method: "POST",
                        body: postData
                    })
                    let resJson = await res.json();
                    resJson.dataenum["customerTypeId"] = Number(user.roldId);
                    resJson.dataenum["registerId"] = Number(user.registerId);
                    resJson.dataenum["term"] = true;
                    resJson.dataenum["announce"] = "11";
                    setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    await GetAmphur(resJson.dataenum.testProvinceCode);
                    await GetTumbon(resJson.dataenum.testProvinceCode, resJson.dataenum.testAmphurCode);
                    setDataAnnounce11(resJson.dataenum.dataAnnounce11);
                } catch (e) {
                    // console.log("err", e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }
        };
        GetCurrentSupportForm();
    }, [])


    useEffect(() => {
        getProfile();
    }, [selectRegisterId])

    useEffect(() => {
        const GetListRegister = async () => {
            try {
                const res = await fetch("/api/OfficerBorrowing/listRegister", {
                    method: "GET",
                    headers: { 'token': user.token },
                })
                const resJson = await res.json();
                setListRegisterOptions(resJson.dataenum);
            } catch (e) {
                console.log("err", e)
            }
        }
        GetListRegister();
    }, [])


    // สมมติ data มาจาก API
    const registerOptions = (listregisterOptions || []).map((x) => ({
        value: x.registerId, // เก็บค่า registerId
        // label: `${x.companyNo ?? "-"} | ${x.customerNo ?? "-"} | ${x.fullName ?? "-"}`,
        label: `${x.fullName ?? "-"}`,

        companyNo: x.companyNo ?? "",
        customerNo: x.customerNo ?? "",
        fullName: x.fullName ?? "",
    }));
    const toText = (v) => (v ?? "").toString().toLowerCase();

    const customFilter = (option, rawInput) => {
        const q = toText(rawInput);
        const d = option && option.data ? option.data : {};
        return [d.companyNo, d.customerNo, d.fullName].some((f) => toText(f).includes(q));
    };



    //calculate announce11
    useEffect(() => {
        async function calculateAmountSupportAnnounce11() {
            setCalculateAmount(0)

            let sumAmount = dataAnnounce11.map(({ amountTotal }) => amountTotal).reduce((prev, current) => Number(prev) + Number(current))
            // console.log("sumAmount", sumAmount)
            setCalculateAmount(sumAmount)

        }
        calculateAmountSupportAnnounce11();
    }, [dataAnnounce11])


    const renderCustomHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
        // const year = format(date, 'yyyy', { locale: th });
        return (
            <div className="react-datepicker__custom-header">
                <div className="react-datepicker__custom-header-left">
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--previous"
                        aria-label="previous month"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
                    </button>
                </div>
                <div className="react-datepicker__custom-header-center">
                    {/* {format(date, 'MMMM', { locale: th })} {Number(year) + 543} */}
                    <select
                        value={thaiMonths[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                            changeMonth(thaiMonths.indexOf(value))
                        }
                    >
                        {thaiMonths.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <select
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(value)}
                    >
                        {years.map(option => (
                            <option key={option} value={option}>
                                {Number(option) + 543}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="react-datepicker__custom-header-right">
                    <button
                        type="button"
                        className="react-datepicker__navigation react-datepicker__navigation--next"
                        aria-label="next month"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                    >
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
                    </button>
                </div>
            </div>
        );
    };

    // ดึง master data หน่วยงานกรมพัฒฯ



    // ดึง master data จังหวัด
    async function GetProvince() {
        setLoading(true);
        try {
            const responseProvince = await fetch("/api/MasterData/getProvince");
            const localtionData = await responseProvince.json();
            // setProvince(localtionData.dataenum);
            setTestProvince(localtionData.dataenum);
        } catch (e) {
            console.log("err => " + e);
        } finally {
            setLoading(false);
        }
    }

    async function GetLawOcu() {
        setLoading(true);
        try {
            const res = await fetch("/api/Borrow/getLawOcuData");
            const data = await res.json();
            setLawOcuData(data.dataenum);
            // console.log(data.dataenum);
        } catch (e) {
            console.log("e => " + e);
        } finally {
            setLoading(false);
        }
    }

    async function GetTitleName() {
        const res = await fetch("/api/MasterData/getTitle");
        const data = await res.json();
        setTitleName(data.dataenum);
    }

    const initialValues = {

        // กรณีเลือกประกาศข้อ 11
        detailAnnounce11Ar: dataAnnounce11,
        supportId: "0",
        roldId: "",
        registerId: Number(user.registerId),
        deptId: "",
        supportTypeId: "9",
        supportTypeName: "ศูนย์ประเมินความรู้ความสามารถ ตามมาตรา 26/4 (2)",
        announce: "11",
        customerTypeId: Number(user.roldId),

        authoriseTitleId: "",
        // authoriseName: "",
        // authorisePersonalId: "",
        authRegisterId: 0,

        // testAddressNo: "",
        // testMoo: "",
        // testSoi: "",
        // testStreet: "",
        // testProvinceCode: "",
        // testAmphurCode: "",
        // testTumbonCode: "",
        // testLocationId: "",
        // testPostCode: "",
        // testPhone: "",
        // testMobile: "",
        // testFax: "",
        // testEmail: "",
        // coordinateName: "",
        // coordinatePhone: "",
        // coordinateMobile: "",
        // coordinateFax: "",
        // coordinateEmail: "",
        amount: calculateAmount,
        paymentName: "",
        // fAuthrisePath: "",
        // fAuthriseIdCardPath: "",
        // fIdCardPath: "",
        fOtherPath: "",
        term: "",
        certificate264: "",
        startDateCertificate: "",
        endDateCertificate: "",
    };



    const onSubmit = async (values, { setFieldValue }) => {
        if (calculateAmount === 0) {
            Swal.fire({
                icon: "info",
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                allowOutsideClick: false,
                allowEscapeKey: false,
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        } else {
            let postData = new FormData();
            postData.append("amount", calculateAmount)
            Object.entries(values).forEach(([key, value]) => {
                if (key.endsWith("11Ar")) {
                    postData.append(key, JSON.stringify(dataAnnounce11));
                } else {
                    postData.append(key, value);
                }
            });

            try {
                let res = await fetch("/api/SupportForm/saveSupportForm", {
                    method: "POST",
                    body: postData,
                });

                let resJson = await res.json();
                // console.log(resJson.dataenum);

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/supporting/")
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e);
            }
        }

    };
    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item.authFullName,
        value: item.authRegisterId
    })) || [];

    const validationSchema = Yup.object().shape({
        supportId: Yup.number(),
        deptId: Yup.string().required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        //     supportName: Yup.string().required("กรุณากรอกชื่อผู้ขอรับเงิน"),
        // authoriseTitleId: Yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
        // authoriseName: Yup.string().required("กรุณากรอกชื่อ"),
        // testAddressNo: Yup.string().required("กรุณากรอกเลขที่"),
        // testMoo: Yup.string(),
        // testSoi: Yup.string(),
        // testStreet: Yup.string(),
        // testProvinceCode: Yup.string().required("กรุณาเลือกจังหวัด"),
        // testAmphurCode: Yup.string().required("กรุณาเลือกอำเภอ/เขต"),
        // testTumbonCode: Yup.string().required("กรุณาเลือกตำบล/แขวง"),
        // testPostCode: Yup.string()
        //   .matches(/^[0-9]{5}$/, "รหัสไปรษณีย์ต้องประกอบไปด้วยตัวเลข 5 หลัก")
        //   .required("กรุณากรอกรหัสไปรษณีย์"),
        // testPhone: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        // testMobile: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        // testFax: Yup.string(),
        // testEmail: Yup.string().email("รูปแบบอีเมลไม่ถูกต้อง").required("กรุณากรอกอีเมล"),
        // coordinateName: Yup.string().required("กรุณากรอกชื่อผู้ประสานงาน"),
        // coordinatePhone: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        // coordinateMobile: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        // coordinateFax: Yup.string(),
        // coordinateEmail: Yup.string().email("รูปแบบอีเมลไม่ถูกต้อง").required("กรุณากรอกอีเมล"),
        amount: Yup.number(),
        // announce: Yup.string().required("กรุณาเลือกประเภท"),
        paymentName: Yup.string().required("กรุณากรอก"),
        // fAuthrisePath: Yup.mixed().when('file', {
        //   is: value => value !== undefined && value !== null,
        //   then: Yup.mixed()
        //     .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
        //       return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        //     })
        //     .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 1MB', value => {
        //       const maxSize = 1000000;
        //       return !value || value.size <= maxSize;
        //     }),
        // }),
        // fAuthriseIdCardPath: Yup.mixed().when('file', {
        //   is: value => value !== undefined && value !== null,
        //   then: Yup.mixed()
        //     .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
        //       return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        //     })
        //     .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 1MB', value => {
        //       const maxSize = 1000000;
        //       return !value || value.size <= maxSize;
        //     }),
        // }),
        fOtherPath: Yup.mixed().when('file', {
            is: value => value !== undefined && value !== null,
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 1MB', value => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        certificate264: Yup.string().required("กรุณากรอกเลขที่หนังสือรับรอง"),
        startDateCertificate: Yup.date().required("กรุณาเลือกวันที่"),
        endDateCertificate: Yup.date().required("กรุณาเลือกวันที่"),

        term: Yup.bool().oneOf([true], "กรุณายอมรับข้อตกลง"),
    });

    async function GetTestLawOnEdit(law) {
        let postData = new FormData();
        postData.append("lawOcuId", law);
        try {
            const res = await fetch("/api/Borrow/getLawOcuDataDetail", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();

            setTestLawOcuData(data.dataenum.map((item) => ({
                value: item.testOccupationCode,
                label: item.testOccupationName
            })))
        } catch (e) {
            // console.log("e => " + e);
        }

    }
    async function GetTestLawOcuDetail(law) {
        let postData = new FormData();
        postData.append("lawOcuId", law);
        try {
            const res = await fetch("/api/Borrow/getLawOcuDataDetail", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            return data.dataenum
        } catch (e) {
            // console.log("e => " + e);
        }
    }


    // ประกาศ11
    const announce11OnEdit = async (row) => {
        // console.log("row", row)
        await GetTestLawOnEdit(row.lawOcupationId)
        setSelectAnnounce11Item(row);
        setIsAnnounce11Editing(true);
        modalToggleAnnounce11(!openModalAnnounce11)
        // console.log("row", row)
    }
    const announce11OnDelete = async (row) => {
        setDataAnnounce11((current) => current.filter((obj) => {
            return obj.id !== row.id
        }))
    }
    const announce11InititalValues = {
        id: "",
        lawOcupationId: "", //สาขาอาชีพ
        lawOccupationName: "", //ชื่อสาขาอาชีพ
        testOcupationId: "", //สาขา
        testOccupationName: "", //ชื่อสาขา
        amountTotal: "", // เป็นจำนวนเงิน(บาท)
        // reciept: "", //เล่มที่ของใบเสร็จรับเงิน
        recieptNo: "", //เลขที่ใบเสร็จรับเงิน
        recieptDate: "", //วันที่ของใบเสร็จรับเงิน
        personTotal: "",
    }
    const announce11ValidateSchema = Yup.object().shape({
        lawOcupationId: Yup.string().required("กรุณาเลือก"),
        testOcupationId: Yup.string().required("กรุณาเลือก"),
        amountTotal: Yup.number().typeError("กรุณากรอกตัวเลข").required("กรุณากรอกจำนวนเงิน"), // เป็นจำนวนเงิน(บาท)
        // reciept: Yup.string().required("กรุณากรอก"), //เล่มที่ของใบเสร็จรับเงิน
        recieptNo: Yup.string().required("กรุณากรอก"), //เลขที่ใบเสร็จรับเงิน
        recieptDate: Yup.date().required("กรุณาเลือก"), //วันที่ของใบเสร็จรับเงิน
        personTotal: Yup.number().typeError("กรุณากรอกตัวเลข").required("กรุณากรอกจำนวนคน")
    })
    const announce11Onsubmit = async (values, { setFieldValue }) => {

        const { lawOcupationId, testOcupationId } = values
        let getTestOccupationName;
        let getLawOccupationName;

        let getSupType = await GetTestLawOcuDetail(lawOcupationId)

        getSupType.forEach((type) => {
            if (type.testOccupationCode == testOcupationId) {
                getTestOccupationName = type.testOccupationName
            }
        })
        // console.log("getSupType",getSupType )

        lawOcuData.forEach((item, i) => {
            if (item.lawOccupationId == lawOcupationId) {
                getLawOccupationName = item.lawOccupationName
            }
        })

        if (values.id !== "") {
            setDataAnnounce11((old) =>
                old.map((row) => {
                    if (row.id === values.id) {
                        return {
                            ...values,
                            id: values.id,
                        };
                    }
                    return row;
                })
            );
            modalToggleAnnounce11(!openModalAnnounce11)
        } else {
            let pre = {
                ...values,
                testOccupationName: getTestOccupationName,
                lawOccupationName: getLawOccupationName,
                id: uuidv4()
            }
            setDataAnnounce11((prev) => [...prev, pre]);
            modalToggleAnnounce11(!openModalAnnounce11)
        }

    }
    const COLUMNSANNOUNCE11 = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "จำนวนเงิน (บาท)",
            accessor: "amountTotal",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-center">
                        {NumberWithCommas(Number(value))}
                    </div>
                );
            },
        },
        {
            Header: "เลขที่ใบเสร็จรับเงิน",
            accessor: "recieptNo",

        },
        {
            Header: "รายละเอียด",
            accessor: "id",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-center">
                        <button
                            type="button"
                            className="btn border border-1 mx-1"
                            onClick={() =>
                                announce11OnEdit(row.original)
                            }
                        >
                            แก้ไข
                        </button>
                        <button
                            type="button"
                            className="btn border border-1 mx-1"
                            onClick={() =>
                                announce11OnDelete(row.original)
                            }
                        >
                            ลบ
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId === "0" ? false : true}
        >
            {({ setFieldValue, values, touched, errors, handleBlur, handleChange }) => {
                console.log("formik.values", values);
                console.log("formik.errors", errors);
                // ดึง master data อำเภอ ที่อยู่ศูนย์ทดสอบ
                async function GetTestAmphur(e) {
                    let postData = new FormData();
                    postData.append("provinceCode", e.target.value);

                    try {
                        const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                            method: "POST",
                            body: postData,
                        });
                        const amphurData = await responseAmphur.json();
                        setTestAmphur(amphurData.dataenum);
                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }
                // ดึง master data ตำบล ที่อยู่ศูนย์ทดสอบ
                async function GetTestTumbon(e) {
                    let postData = new FormData();
                    postData.append("provinceCode", values.testProvinceCode);
                    postData.append("amphurCode", e.target.value);
                    try {
                        let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                            method: "POST",
                            body: postData,
                        });
                        const tumbonData = await responseTumbon.json();
                        setTestTumbon(tumbonData.dataenum);
                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }
                // หา location_id ที่อยู่ศูนย์ทดสอบ
                async function GetTestLocationsId(e) {
                    let postData = new FormData();
                    postData.append("provinceCode", values.testProvinceCode);
                    postData.append("amphurCode", values.testAmphurCode);
                    postData.append("tumbonCode", e.target.value);
                    try {
                        let res = await fetch("/api/MasterData/getLocationId", {
                            method: "POST",
                            body: postData,
                        });
                        const locationId = await res.json();

                        let setLocationId = locationId.dataenum
                            .map(({ locationId }) => locationId)
                            .join()
                            .toString();
                        setFieldValue("testLocationId", setLocationId);
                        // console.log(setLocationId);
                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }

                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">
                                <Form className="p-5 mb-4">

                                    <Label className="customer-type text-center px-5">
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                        พ.ศ. 2545 กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>

                                    <FormGroup className="mb-3">
                                        <Label htmlFor="establishmentId" className="fw-semibold">
                                            เลือกผู้ใช้งานที่จะลงทะเบียนให้ <span className="require-input">*</span>
                                        </Label>

                                        <Select
                                            options={registerOptions}
                                            filterOption={customFilter}
                                            placeholder="ค้นหาโดย เลขทะเบียนนิติบุคคล 13 หลัก, เลขสถานประกอบการ 10 หลัก หรือ ชื่อสถานประกอบการ"
                                            isClearable
                                            noOptionsMessage={() => "ไม่พบข้อมูล"}
                                            onChange={(selected) => {
                                                console.log("selected.value", selected.value);
                                                // selected = { value, label, companyNo, customerNo, fullName }
                                                setSelectRegisterId(selected.value)
                                                setFieldValue("registerId", selected ? selected.value : "");
                                            }}
                                            value={registerOptions.find(item => item.value == selectRegisterId)}
                                        />
                                    </FormGroup>
                                    {/* ปุ่มลงทะเบียนใหม่ */}
                                    {/* <div className="d-flex align-items-center mt-2">
                                        <span className="me-3 text-muted">
                                            หากยังไม่ได้ลงทะเบียนสถานประกอบการในระบบ
                                        </span>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary rounded-pill px-4"
                                            onClick={() => navigate("/register-establishment")} // 🔧 route ปรับตามจริง
                                        >
                                            ลงทะเบียน
                                        </button>
                                    </div> */}
                                    {/* ดึงข้อมูลมาแสดง */}
                                    <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.licenseTestName ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            เลขทะเบียนนิติบุคคล
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.customerNo ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>

                                    <Label className="mb-3 input-color">กรุณากรอกรายละเอียดการขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ยื่นคำขอที่
                                            <span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.deptId}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Col>
                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>



                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    <FormGroup row>
                                        <Label for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span className="require-input">*</span>
                                            {touched.authRegisterId &&
                                                errors.authRegisterId ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.authRegisterId}
                                                </span>
                                            ) : null}

                                        </Label>
                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Field
                                                    name="authRegisterId"
                                                    component={FormikSelect}
                                                    options={authRegisterOptions}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                />
                                            </div>

                                        </div>
                                    </FormGroup>



                                    {/* ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน */}
                                    <div className="pt-3">
                                        <Label for="">
                                            ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน
                                        </Label>
                                        {/* ที่อยู่ */}
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label for="testAddressNo" sm={2}>
                                                    เลขที่<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testAddressNo"
                                                        name="testAddressNo"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.testAddressNo && errors.testAddressNo
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testAddressNo}
                                                        value={userProfile?.address?.addressNo ?? "-"}
                                                    />
                                                </Col>

                                                <Label for="testMoo" sm={2}>
                                                    หมู่ที่
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testMoo"
                                                        name="testMoo"
                                                        disabled
                                                        type="text"
                                                        className="rounded-pill text-center input-color"
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testMoo}
                                                        value={userProfile?.address?.moo ?? "-"}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="testSoi" sm={2}>
                                                    ซอย
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testSoi"
                                                        name="testSoi"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.testSoi && errors.testSoi
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testSoi}
                                                        value={userProfile?.address?.soi ?? "-"}

                                                    />
                                                </Col>

                                                <Label for="" sm={2}>
                                                    ถนน
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testStreet"
                                                        name="testStreet"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.testStreet && errors.testStreet
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testStreet}
                                                        value={userProfile?.address?.street ?? "-"}

                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="testProvinceCode" sm={2}>
                                                    จังหวัด<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testProvinceCode"
                                                        name="testProvinceCode"
                                                        disabled
                                                        value={userProfile?.address?.provinceCode ?? "-"}
                                                        type="select"
                                                        className={
                                                            touched.testProvinceCode &&
                                                                errors.testProvinceCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                    // onChange={(e) => {
                                                    //     handleChange(e);
                                                    //     GetTestAmphur(e);
                                                    //     setFieldValue("testAmphurCode", "กรุณาเลือกอำเภอ/เขต");
                                                    //     setFieldValue("testTumbonCode", "กรุณาเลือกตำบล/แขวง");
                                                    // }}
                                                    // value={values?.testProvinceCode}
                                                    >
                                                        <option defaultValue="กรุณาเลือกจังหวัด">
                                                            กรุณาเลือกจังหวัด
                                                        </option>
                                                        {testProvince?.map((province) => (
                                                            <option
                                                                key={province.provinceCode}
                                                                value={province.provinceCode}
                                                            >
                                                                {province.provinceName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>

                                                <Label for="testAmphurCode" sm={2}>
                                                    อำเภอ/เขต<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testAmphurCode"
                                                        name="testAmphurCode"
                                                        disabled
                                                        type="select"
                                                        className={
                                                            touched.testAmphurCode &&
                                                                errors.testAmphurCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        // onChange={(e) => {
                                                        //     handleChange(e);
                                                        //     GetTestTumbon(e);
                                                        //     setFieldValue(
                                                        //         "testTumbonCode",
                                                        //         "กรุณาเลือกตำบล/แขวง"
                                                        //     );
                                                        // }}
                                                        // value={values?.testAmphurCode}
                                                        value={userProfile?.address?.amphurCode ?? "-"}

                                                    >
                                                        <option defaultValue="กรุณาเลือกอำเภอ/เขต">
                                                            กรุณาเลือกอำเภอ/เขต
                                                        </option>
                                                        {testAmphur?.map((amphur) => (
                                                            <option
                                                                key={amphur.amphurCode}
                                                                value={amphur.amphurCode}
                                                            >
                                                                {amphur.amphurName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="testTumbonCode" sm={2}>
                                                    ตำบล/แขวง<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="testTumbonCode"
                                                        name="testTumbonCode"
                                                        disabled
                                                        type="select"
                                                        className={
                                                            touched.testTumbonCode &&
                                                                errors.testTumbonCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        // onChange={(e) => {
                                                        //     handleChange(e);
                                                        //     GetTestLocationsId(e);
                                                        // }}
                                                        // value={values?.testTumbonCode}
                                                        value={userProfile?.address?.tumbonCode ?? "-"}

                                                    >
                                                        <option defaultValue="กรุณาเลือกตำบล/แขวง">
                                                            กรุณาเลือกตำบล/แขวง
                                                        </option>
                                                        {testTumbon?.map((tumbon) => (
                                                            <option
                                                                key={tumbon.tumbonCode}
                                                                value={tumbon.tumbonCode}
                                                            >
                                                                {tumbon.tumbonName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>

                                                <Label for="testPostCode" sm={2}>
                                                    รหัสไปรษณีย์<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        maxLength={5}
                                                        id="testPostCode"
                                                        name="testPostCode"
                                                        type="text"
                                                        disabled
                                                        className={
                                                            touched.testPostCode && errors.testPostCode
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        // value={values?.testPostCode}
                                                        value={userProfile?.address?.postCode ?? "-"}

                                                    />
                                                </Col>
                                            </FormGroup>

                                        </div>
                                    </div>



                                    {/* ชื่อผู้ประสานงาน */}
                                    <FormGroup>
                                        <Label for="contact">
                                            ชื่อผู้ประสานงาน
                                            <span className="require-input">*</span>

                                        </Label>
                                        <Col>
                                            <Input
                                                className={
                                                    touched.coordinateName && errors.coordinateName
                                                        ? "input-error rounded-pill text-center input-color"
                                                        : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                disabled
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                value={values?.coordinateName}
                                            // value={userProfile?.coordinateName}


                                            />
                                        </Col>
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label for="coordinatePhone" sm={2}>
                                                    โทรศัพท์<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        className={
                                                            touched.coordinatePhone &&
                                                                errors.coordinatePhone
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        disabled
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinatePhone}
                                                    />
                                                </Col>

                                                <Label for="coordinateMobile" sm={2}>
                                                    โทรศัพท์มือถือ<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.coordinateMobile &&
                                                                errors.coordinateMobile
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinateMobile}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="soi" sm={2}>
                                                    โทรสาร
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.coordinateFax && errors.coordinateFax
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinateFax}
                                                    />
                                                </Col>

                                                <Label for="coordinateEmail" sm={2}>
                                                    อีเมล<span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        disabled
                                                        type="text"
                                                        className={
                                                            touched.coordinateEmail &&
                                                                errors.coordinateEmail
                                                                ? "input-error rounded-pill text-center input-color"
                                                                : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e);
                                                        }}
                                                        value={values?.coordinateEmail}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>



                                    <FormGroup className="mt-3">
                                        <Label for="certificate264">
                                            เป็นศูนย์ประเมินความรู้ความสามารถ ตามมาตรา 26/4 (2) ได้รับหนังสือรับรองเลขที่
                                            <span className="require-input">*</span>
                                            {touched.certificate264 && errors.certificate264 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.certificate264}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Col>
                                            <Input
                                                id="certificate264"
                                                name="certificate264"
                                                type="text"
                                                className={
                                                    touched.certificate264 && errors.certificate264
                                                        ? "input-error rounded-pill text-center input-color"
                                                        : "rounded-pill text-center input-color"
                                                }
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values?.certificate264}
                                            // {...getFieldProps('deptId')}
                                            />

                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="d-flex justify-content-between">
                                        <div className="w-50 mx-1">
                                            <Label for="startDateCertificate">
                                                ออก ให้ ณ วันที่
                                                <span className="require-input">*</span>
                                                {touched.startDateCertificate && errors.startDateCertificate ? (
                                                    <span className="text-left text-danger px-1">
                                                        {errors.startDateCertificate}
                                                    </span>
                                                ) : null}
                                            </Label>
                                            <Col>
                                                <Field name="startDateCertificate">
                                                    {({ field, meta, form }) => {
                                                        const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                                        // console.log("select Data =>", selectedDate)
                                                        const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                                        const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                                        const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                                        return (
                                                            <DatePicker
                                                                selected={selectedDate}
                                                                locale="th-buddhist"
                                                                showIcon
                                                                calendarClassName="thai-buddhist"
                                                                dateFormat="dd MMMM yyyy"
                                                                value={formattedDate}
                                                                isClearable={true}
                                                                placeholderText="กรุณาเลือก"
                                                                renderCustomHeader={renderCustomHeader}
                                                                onChange={(date) => {
                                                                    if (date instanceof Date && !isNaN(date)) {
                                                                        const year = date.getFullYear();
                                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                        const day = String(date.getDate()).padStart(2, '0');
                                                                        const formattedDate = `${year}-${month}-${day}`;
                                                                        // console.log("format", typeof (formattedDate))
                                                                        form.setFieldValue(field.name, formattedDate);
                                                                    } else {
                                                                        form.setFieldValue(field.name, "");
                                                                    }
                                                                    // calculateDate(date)
                                                                }}
                                                                customInput={
                                                                    <Input
                                                                        type="text"
                                                                        className={
                                                                            touched.startDateCertificate && errors.startDateCertificate
                                                                                ? "input-error rounded-pill text-center input-color"
                                                                                : "rounded-pill text-center input-color"
                                                                        }
                                                                        value={formattedDate}
                                                                        onChange={() => { }}
                                                                        onBlur={field.onBlur}
                                                                    />
                                                                }
                                                            />
                                                        )
                                                    }}
                                                </Field>

                                            </Col>
                                        </div>

                                        <div className="w-50 mx-1">
                                            <Label for="endDateCertificate">
                                                ใช้ได้จนถึงวันที่
                                                <span className="require-input">*</span>
                                                {touched.endDateCertificate && errors.endDateCertificate ? (
                                                    <span className="text-left text-danger px-1">
                                                        {errors.endDateCertificate}
                                                    </span>
                                                ) : null}
                                            </Label>
                                            <Col>
                                                <Field name="endDateCertificate">
                                                    {({ field, meta, form }) => {
                                                        const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                                        // console.log("sekect", selectedDate)
                                                        const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                                        const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                                        const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;
                                                        return (
                                                            <DatePicker
                                                                selected={selectedDate}
                                                                locale="th-buddhist"
                                                                calendarClassName="thai-buddhist"
                                                                dateFormat="dd MMMM yyyy"
                                                                value={formattedDate}
                                                                isClearable={true}
                                                                placeholderText="กรุณาเลือก"
                                                                renderCustomHeader={renderCustomHeader}
                                                                onChange={(date) => {
                                                                    if (date instanceof Date && !isNaN(date)) {
                                                                        const year = date.getFullYear();
                                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                        const day = String(date.getDate()).padStart(2, '0');
                                                                        const formattedDate = `${year}-${month}-${day}`;
                                                                        // console.log("format", typeof (formattedDate))
                                                                        form.setFieldValue(field.name, formattedDate);
                                                                    } else {
                                                                        form.setFieldValue(field.name, "");
                                                                    }
                                                                    // calculateDate(date)
                                                                }}
                                                                customInput={
                                                                    <Input
                                                                        type="text"
                                                                        className={
                                                                            touched.endDateCertificate && errors.endDateCertificate
                                                                                ? "input-error rounded-pill text-center input-color"
                                                                                : "rounded-pill text-center input-color"
                                                                        }
                                                                        value={formattedDate}
                                                                        onChange={() => { }}
                                                                        onBlur={field.onBlur}
                                                                    />
                                                                }
                                                            />
                                                        )
                                                    }}
                                                </Field>
                                            </Col>
                                        </div>
                                    </FormGroup>

                                    {/* ประกาศข้อ 11 */}
                                    <FormGroup className="mt-3">

                                        <Label>
                                            ดำเนินการประเมินความรู้ความสามารถและส่งเงินค่าธรรมเนียมเข้ากองทุนพัฒนาฝีมือแรงงานตามมาตรา 27
                                            <br />
                                            วรรคสอง (3/1)
                                        </Label>
                                    </FormGroup>
                                    <Formik
                                        initialValues={isAnnounce11Editing ? selectAnnounce11Item : announce11InititalValues}
                                        validationSchema={announce11ValidateSchema}
                                        onSubmit={announce11Onsubmit}
                                        enableReinitialize
                                    >
                                        {({
                                            values,
                                            handleChange,
                                            handleBlur,
                                            setFieldValue,
                                            setFieldError,
                                            setValues,
                                            resetForm,
                                            errors,
                                            touched,
                                            submitForm,
                                            isValid,
                                            setFieldTouched
                                        }) => {

                                            console.log("value announe11", values);
                                            console.log("errors announe11", errors);

                                            // === ใช้ searchReceipt แบบเดียวกับตัวอย่าง ===
                                            const searchReceipt = async (receiptNo) => {
                                                if (!receiptNo?.trim()) {
                                                    Swal.fire({ icon: "warning", title: "กรุณากรอกเลขที่ใบเสร็จ", confirmButtonColor: "#0A66C2" });
                                                    return;
                                                }
                                                const formData = new FormData();
                                                formData.append("receiptNo", receiptNo);
                                                try {
                                                    const res = await fetch("/api/SupportForm/searchReceiptNo", {
                                                        method: "POST",
                                                        body: formData
                                                    });
                                                    const resJson = await res.json();
                                                    const data = resJson.dataenum;
                                                    if (resJson.status === 0) {
                                                        Swal.fire({ icon: "info", title: `${resJson.message}`, confirmButtonColor: "#0A66C2" });
                                                        return;
                                                    }

                                                    // เซ็ตค่าที่ได้จาก API
                                                    setFieldValue("recieptNo", data.receiptNo ?? receiptNo);
                                                    setFieldValue("amountTotal", data.amount ?? "");
                                                    setFieldValue("personTotal", data.personTotal ?? "");
                                                    setFieldValue("testOcupationId", data.testOccupationCode ?? "");
                                                    setFieldValue("recieptDate", data.createDate);

                                                    // ตรวจเงื่อนไขอายุวันที่
                                                    // calculateDate(new Date(data.createDate));

                                                    // โหลด test occupations ตาม lawOccupationId แล้วตั้งค่า testOcupationId ให้ตรงกับใบเสร็จ
                                                    const lawId = data.lawOccupationId ?? "";
                                                    if (lawId) {
                                                        const postData = new FormData();
                                                        postData.append("lawOcuId", lawId);
                                                        try {
                                                            const res2 = await fetch("/api/Borrow/getLawOcuDataDetail", {
                                                                method: "POST",
                                                                body: postData,
                                                            });
                                                            const d2 = await res2.json();

                                                            // map เป็น [{value,label}]
                                                            const options = (d2?.dataenum ?? []).map((item) => ({
                                                                value: item.testOccupationCode,
                                                                label: item.testOccupationName,
                                                            }));
                                                            setTestLawOcuData(options);

                                                            // ถ้า code จากใบเสร็จมีอยู่ใน options ให้ set ให้เลย
                                                            if (data.testOccupationCode) {
                                                                const exist = options.find((o) => o.value === data.testOccupationCode);
                                                                if (exist) {
                                                                    setFieldValue("testOcupationId", data.testOccupationCode);
                                                                }
                                                            }
                                                        } catch (_) {
                                                            // เงียบไว้หรือจะแจ้งเตือนเบา ๆ ก็ได้
                                                        }
                                                    }
                                                    setFieldValue("lawOcupationId", lawId);
                                                } catch (e) {
                                                    console.log("err", e);
                                                }
                                            };

                                            // const calculateDate = (date) => {
                                            //     if (date === null) {
                                            //         setFieldError("recieptDate", `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `);
                                            //         setFieldValue("recieptDate", "");
                                            //     } else {
                                            //         const baseDay = Number(conditionDate) * 24 * 60 * 60 * 1000;
                                            //         const difference = new Date() - date;
                                            //         if (difference > baseDay) {
                                            //             Swal.fire({
                                            //                 icon: "warning",
                                            //                 title: `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `,
                                            //                 allowOutsideClick: false,
                                            //                 allowEscapeKey: false,
                                            //                 text: `กรุณาตรวจสอบข้อมูลอีกครั้ง`,
                                            //                 confirmButtonColor: "#0A66C2",
                                            //                 confirmButtonText: "ตกลง",
                                            //             }).then(() => {
                                            //                 setFieldError("recieptDate", `วันที่มีจำนวนมากกว่า ${conditionDate} วัน `);
                                            //                 setFieldValue("recieptDate", "");
                                            //                 setFieldTouched("recieptDate", true);
                                            //             });
                                            //         }
                                            //     }
                                            // };

                                            const onAddAnnoune11Detail = () => {
                                                setIsAnnounce11Editing(false);
                                                setSelectAnnounce11Item(null);
                                                resetForm();
                                                modalToggleAnnounce11();
                                            };

                                            const AddDetailAnnounce11Btn = () => (
                                                <button
                                                    className="btn border border-1 text-white btn-green"
                                                    onClick={() => onAddAnnoune11Detail()}
                                                >
                                                    <BsPlusLg className="mx-2" />
                                                    เพิ่ม
                                                </button>
                                            );

                                            async function GetLawOcuDetail(e) {
                                                const postData = new FormData();
                                                postData.append("lawOcuId", e.target.value);
                                                try {
                                                    const res = await fetch("/api/Borrow/getLawOcuDataDetail", {
                                                        method: "POST",
                                                        body: postData,
                                                    });
                                                    const data = await res.json();
                                                    setTestLawOcuData(
                                                        (data?.dataenum ?? []).map((item) => ({
                                                            value: item.testOccupationCode,
                                                            label: item.testOccupationName,
                                                        }))
                                                    );
                                                } catch (e) {
                                                    // noop
                                                }
                                            }

                                            return (
                                                <div className="">
                                                    <CreateTableComponent
                                                        column={COLUMNSANNOUNCE11}
                                                        dataInput={dataAnnounce11}
                                                        FormInput={AddDetailAnnounce11Btn}
                                                        showEntrie={false}
                                                        showPage={false}
                                                    />

                                                    <Modal
                                                        isOpen={openModalAnnounce11}
                                                        toggle={modalToggleAnnounce11}
                                                        size="lg"
                                                        centered
                                                        scrollable
                                                        className="modal-bordered"
                                                        backdrop={"static"}
                                                        keyboard={false}
                                                    >
                                                        <ModalHeader className="styled-modal text-center" toggle={modalToggleAnnounce11}>
                                                            กรุณากรอกข้อมูล
                                                        </ModalHeader>
                                                        <ModalBody className="form-border">
                                                            <div style={{ maxWidth: "770px", width: "100%" }}>
                                                                <Form autoComplete="off" className="">
                                                                    <div className="p-4">
                                                                        <FormGroup>
                                                                            <Field name="id" disabled={true} className="d-none" />
                                                                            <div>
                                                                                {/* === เปลี่ยนมาใช้ “เลขที่ใบเสร็จรับเงิน” + ปุ่มค้นหา เรียก searchReceipt === */}
                                                                                <Label className="mt-2">เลขที่ใบเสร็จรับเงิน</Label>
                                                                                {touched.recieptNo && errors.recieptNo ? (
                                                                                    <span className="text-left text-danger px-1">{errors.recieptNo}</span>
                                                                                ) : null}
                                                                                <Field name="recieptNo">
                                                                                    {({ field, meta }) => (
                                                                                        <div className="d-flex gap-2">
                                                                                            <Input
                                                                                                type="text"
                                                                                                className={
                                                                                                    meta.touched && meta.error
                                                                                                        ? "input-error rounded-pill text-center input-color"
                                                                                                        : "rounded-pill text-center input-color"
                                                                                                }
                                                                                                {...field}
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === "Enter") {
                                                                                                        e.preventDefault();
                                                                                                        searchReceipt(field.value);
                                                                                                    }
                                                                                                }}
                                                                                                placeholder="กรอกเลขที่ใบเสร็จรับเงินเพื่อทำการค้นหา"
                                                                                            />
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn border border-1 text-white btn-green"
                                                                                                onClick={() => searchReceipt(field.value)}
                                                                                                title="ค้นหาใบเสร็จ"
                                                                                            >
                                                                                                ค้นหา
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </Field>

                                                                                {/* วันที่จากใบเสร็จ — disabled และเติมอัตโนมัติจาก searchReceipt */}
                                                                                <Label className="mt-2">ลงวันที่</Label>
                                                                                {touched.recieptDate && errors.recieptDate ? (
                                                                                    <span className="text-left text-danger px-1">
                                                                                        {errors.recieptDate}
                                                                                    </span>
                                                                                ) : null}
                                                                                <Field name="recieptDate">
                                                                                    {({ field, meta, form }) => {
                                                                                        const selectedDate = field.value ? new Date(field.value) : null;
                                                                                        const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null;
                                                                                        const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                                                                        const formattedDate = selectedDateInBE
                                                                                            ? `${format(selectedDateInBE, 'dd')} ${monthInThai} ${format(selectedDateInBE, 'yyyy')}`
                                                                                            : null;

                                                                                        return (
                                                                                            <DatePicker
                                                                                                selected={selectedDate}
                                                                                                locale="th-buddhist"
                                                                                                showIcon
                                                                                                calendarClassName="thai-buddhist"
                                                                                                dateFormat="dd MMMM yyyy"
                                                                                                value={formattedDate}
                                                                                                isClearable
                                                                                                placeholderText="กรุณาเลือก"
                                                                                                renderCustomHeader={renderCustomHeader}
                                                                                                onChange={(date) => {
                                                                                                    if (date instanceof Date && !isNaN(date)) {
                                                                                                        const year = date.getFullYear();
                                                                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                                                        const day = String(date.getDate()).padStart(2, '0');
                                                                                                        const formatted = `${year}-${month}-${day}`;
                                                                                                        form.setFieldValue(field.name, formatted);
                                                                                                    } else {
                                                                                                        form.setFieldValue(field.name, "");
                                                                                                    }
                                                                                                    // calculateDate(date);
                                                                                                }}
                                                                                                // ปิดแก้ไขตรง ๆ ให้ค่ามาจากการค้นหาเป็นหลัก
                                                                                                disabled
                                                                                                customInput={
                                                                                                    <Input
                                                                                                        type="text"
                                                                                                        className={
                                                                                                            touched.recieptDate && errors.recieptDate
                                                                                                                ? "input-error rounded-pill text-center input-color"
                                                                                                                : "rounded-pill text-center input-color"
                                                                                                        }
                                                                                                        value={formattedDate ?? ""}
                                                                                                        onChange={() => { }}
                                                                                                        onBlur={field.onBlur}
                                                                                                    />
                                                                                                }
                                                                                            />
                                                                                        );
                                                                                    }}
                                                                                </Field>

                                                                                {/* สาขาอาชีพ (จากใบเสร็จ) */}
                                                                                <Label className="mt-2">กรุณาเลือกสาขาอาชีพ</Label>
                                                                                {touched.lawOcupationId && errors.lawOcupationId ? (
                                                                                    <span className="text-left text-danger px-1">
                                                                                        {errors.lawOcupationId}
                                                                                    </span>
                                                                                ) : null}
                                                                                <Field name="lawOcupationId">
                                                                                    {({ field, meta }) => (
                                                                                        <Input
                                                                                            type="select"
                                                                                            className={
                                                                                                meta.touched && meta.error
                                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                                    : "rounded-pill text-center input-color"
                                                                                            }
                                                                                            {...field}
                                                                                            onChange={(e) => {
                                                                                                handleChange(e);
                                                                                                GetLawOcuDetail(e);
                                                                                            }}
                                                                                            // ค่าในเคสนี้มาจาก searchReceipt — ปิดการแก้ไขเพื่อป้องกันผิดพลาด
                                                                                            disabled
                                                                                        >
                                                                                            <option defaultValue={"--กรุณาเลือกสาขาอาชีพ--"}>
                                                                                                --กรุณาเลือกสาขาอาชีพ--
                                                                                            </option>
                                                                                            {lawOcuData.map((lawOcu) => (
                                                                                                <option
                                                                                                    key={lawOcu.lawOccupationId}
                                                                                                    value={lawOcu.lawOccupationId}
                                                                                                >
                                                                                                    {lawOcu.lawOccupationName}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Input>
                                                                                    )}
                                                                                </Field>

                                                                                {/* สาขา (Test Occupation) */}
                                                                                <Label className="mt-3">กรุณาเลือกสาขา</Label>
                                                                                {touched.testOcupationId && errors.testOcupationId ? (
                                                                                    <span className="text-left text-danger px-1">
                                                                                        {errors.testOcupationId}
                                                                                    </span>
                                                                                ) : null}
                                                                                <Field name="testOcupationId">
                                                                                    {({ field, meta }) => (
                                                                                        <Input
                                                                                            type="select"
                                                                                            className={
                                                                                                meta.touched && meta.error
                                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                                    : "rounded-pill text-center input-color"
                                                                                            }
                                                                                            {...field}
                                                                                            disabled
                                                                                        >
                                                                                            <option defaultValue={"--กรุณาเลือกสาขา--"}>
                                                                                                --กรุณาเลือกสาขา--
                                                                                            </option>
                                                                                            {testLawOcuData.map((opt, idx) => (
                                                                                                <option key={`${opt.value}-${idx}`} value={opt.value}>
                                                                                                    {opt.label}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Input>
                                                                                    )}
                                                                                </Field>

                                                                                {/* จำนวนคน */}
                                                                                <Label className="mt-3">จำนวนคน</Label>
                                                                                {touched.personTotal && errors.personTotal ? (
                                                                                    <span className="text-left text-danger px-1">
                                                                                        {errors.personTotal}
                                                                                    </span>
                                                                                ) : null}
                                                                                <Field name="personTotal">
                                                                                    {({ field, meta }) => (
                                                                                        <Input
                                                                                            type="text"
                                                                                            className={
                                                                                                meta.touched && meta.error
                                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                                    : "rounded-pill text-center input-color"
                                                                                            }
                                                                                            {...field}
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                </Field>

                                                                                {/* จำนวนเงิน */}
                                                                                <Label className="mt-2">เป็นจำนวนเงิน</Label>
                                                                                {touched.amountTotal && errors.amountTotal ? (
                                                                                    <span className="text-left text-danger px-1">
                                                                                        {errors.amountTotal}
                                                                                    </span>
                                                                                ) : null}
                                                                                <Field name="amountTotal">
                                                                                    {({ field, meta }) => (
                                                                                        <Input
                                                                                            type="text"
                                                                                            className={
                                                                                                meta.touched && meta.error
                                                                                                    ? "input-error rounded-pill text-center input-color"
                                                                                                    : "rounded-pill text-center input-color"
                                                                                            }
                                                                                            {...field}
                                                                                            disabled
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                            </div>
                                                                        </FormGroup>
                                                                    </div>

                                                                    <ModalFooter className="d-flex justify-content-center">
                                                                        <button
                                                                            type="submit"
                                                                            className="btn-blue w-50"
                                                                        // disabled={!isValid}
                                                                        >
                                                                            บันทึก
                                                                        </button>
                                                                    </ModalFooter>
                                                                </Form>
                                                            </div>
                                                        </ModalBody>
                                                    </Modal>
                                                </div>
                                            );
                                        }}
                                    </Formik>


                                    {/* แบนไฟล์ต่างๆ */}
                                    <FormGroup className="mt-3">
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                            พ.ศ. 2545 เป็นจำนวนเงินทั้งสิ้น
                                            <span className="require-input">*</span>
                                            {touched.amount && errors.amount ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.amount}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="amount"
                                            name="amount"
                                            type="text"
                                            disabled={true}
                                            className={
                                                touched.amount && errors.amount
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={NumberWithCommas(calculateAmount)}
                                        />
                                    </FormGroup>

                                    <FormGroup className="">
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span className="require-input">*</span>
                                            {touched.paymentName && errors.paymentName ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.paymentName}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={
                                                touched.paymentName && errors.paymentName
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={values?.paymentName}
                                        />
                                    </FormGroup>

                                    {/* <FormGroup className="">
                    <Label>
                      หนังสือมอบอำนาจพร้อมติดอากรแสตมป์ (กรณีมอบอำนาจ)
                      {touched.fAuthrisePath && errors.fAuthrisePath ? (
                        <span className="text-left text-danger px-1">
                          {errors.fAuthrisePath}
                        </span>
                      ) : null}
                    </Label>
                    <Input
                      id="fAuthrisePath"
                      name="fAuthrisePath"
                      type="file"
                      className="rounded-pill text-center input-color"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (e.target && e.target.files[0]) {
                          setFieldValue("fAuthrisePath", e.target.files[0]);
                        }
                      }}
                    />
                  </FormGroup>

                  <FormGroup className="">
                    <Label for="fAuthriseIdCardPath">
                      สำเนาบัตรประชาชนของผู้มอบอำนาจ (กรณีมอบอำนาจ)
                      {touched.fAuthriseIdCardPath && errors.fAuthriseIdCardPath ? (
                        <span className="text-left text-danger px-1">
                          {errors.fAuthriseIdCardPath}
                        </span>
                      ) : null}
                    </Label>
                    <Input
                      id="fAuthriseIdCardPath"
                      name="fAuthriseIdCardPath"
                      type="file"
                      className="rounded-pill text-center input-color"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (e.target && e.target.files[0]) {
                          setFieldValue("fAuthriseIdCardPath", e.target.files[0]);
                        }
                      }}
                    />
                  </FormGroup> */}

                                    {/* <FormGroup className="">
                    <Label>
                      บัตรประจำตัวประชาชน (กรณีบุคคลธรรมดา)

                      {touched.fIdCardPath && errors.fIdCardPath ? (
                        <span className="text-left text-danger px-1">
                          {errors.fIdCardPath}
                        </span>
                      ) : null}
                    </Label>
                    <Input
                      id="fIdCardPath"
                      name="fIdCardPath"
                      type="file"
                      className={
                        touched.fIdCardPath && errors.fIdCardPath
                          ? "input-error rounded-pill text-center input-color"
                          : "rounded-pill text-center input-color"
                      }
                      onBlur={handleBlur}
                      onChange={(e) => {
                        //     handleChange(e);
                        if (e.target && e.target.files[0]) {
                          setFieldValue("fIdCardPath", e.target.files[0]);
                        }
                      }}
                    />
                  </FormGroup> */}

                                    <FormGroup>
                                        <Label>
                                            เอกสารอื่นๆ (ถ้ามี)
                                            {touched.fOtherPath && errors.fOtherPath ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.fOtherPath}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Input
                                            id="fOtherPath"
                                            name="fOtherPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                //     handleChange(e);
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fOtherPath", e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </FormGroup>

                                    {/* term */}
                                    <div className="d-flex">
                                        <Input
                                            type="checkbox"
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={values?.term}
                                            checked={values?.term}
                                        />
                                        <Label for="term" className="mx-2 customer-type">
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>
                                    </div>
                                    <FormGroup className="d-flex justify-content-center mt-3">
                                        <button
                                            type="submit"
                                            disabled={values?.term ? false : true}
                                            // disabled={!(isValid && dirty)}
                                            className="btn-blue px-4 w-25"
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </FormGroup>

                                </Form>
                            </div>
                        ) : (
                            <Loading />
                        )}
                    </Container>
                );
            }}
        </Formik>
    );
}
